import { ReactNode, useState } from "react";
import classNames from "classnames";
import "./AuthViewContainer.scss";
import { WhiteLabelSettingsLoader } from "modules/settings/components/WhiteLabelSettingsLoader";
import {
  selectEnableAgencyWhiteLabelling,
  selectWhiteLabelSignInBackgroundURL,
} from "modules/settings/redux/selectors";
import { useSelector } from "react-redux";
import { useI18n } from "i18n";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { useStyles } from "./AuthViewContainerStyles";

interface Props {
  children: ReactNode;
  className?: string;
}

const AuthViewContainer = ({ children, className }: Props): JSX.Element => {
  const [isWhiteLabelSettingsLoading, setIsWhiteLabelSettingsLoading] =
    useState(false);
  const whiteLabelSignInBackgroundURL = useSelector(
    selectWhiteLabelSignInBackgroundURL,
  );
  const enableAgencyWhiteLabelling = useSelector(
    selectEnableAgencyWhiteLabelling,
  );
  const classes = useStyles({
    customBackgroundURL: enableAgencyWhiteLabelling
      ? whiteLabelSignInBackgroundURL
      : undefined,
  });
  const { t } = useI18n(["common"]);

  return (
    <div className={classNames(className, classes.root, "auth-view-container")}>
      {children}
      <WhiteLabelSettingsLoader setIsLoading={setIsWhiteLabelSettingsLoading} />
      {isWhiteLabelSettingsLoading && (
        <div className="login-loading">
          <PageLoader
            message={t("wait")}
            data-testid="auth-view-container-loading"
          />
        </div>
      )}
    </div>
  );
};

export default AuthViewContainer;
